import { api } from './core';
import type {
  GalleryCategory,
  GalleryMapResponse,
  RebuildGalleryResponse,
  UpdateGalleryProjectPayload,
  GalleryProject,
} from '../../types/projectGallery';

export async function rebuildGallery(): Promise<RebuildGalleryResponse> {
  const { data } = await api.post<RebuildGalleryResponse>(
    '/project-gallery/admin/rebuild',
    { overwrite_existing: true },
    { timeout: 600000 }
  );
  return data;
}

export async function getAdminCategories(): Promise<GalleryCategory[]> {
  const { data } = await api.get<GalleryCategory[]>('/project-gallery/admin/categories');
  return data;
}

export async function updateGalleryProject(
  versionId: number,
  payload: UpdateGalleryProjectPayload
): Promise<GalleryProject> {
  const { data } = await api.patch<GalleryProject>(`/project-gallery/admin/projects/${versionId}`, payload);
  return data;
}

export async function getGalleryMap(): Promise<GalleryMapResponse> {
  const { data } = await api.get<GalleryMapResponse>('/project-gallery/map');
  return data;
}
